import _cloneDeep from "lodash/cloneDeep";
import { ShopLocation, Shops, ShopDetailsWithDistance } from "../../../models/state";

export const distance = (location1: ShopLocation, location2: ShopLocation) => {
    const R = 6371;
    const p = Math.PI / 180;
    const c = Math.cos;
    const a =
        0.5 -
        c((location2.lat - location1.lat) * p) / 2 +
        (c(location1.lat * p) * c(location2.lat * p) * (1 - c((location2.lng - location1.lng) * p))) / 2;

    const distanceKm = 2 * R * Math.asin(Math.sqrt(a));
    return distanceKm;
};

export const isNear = (location1: ShopLocation, location2: ShopLocation, threshold: number) =>
    distance(location1, location2) < threshold;

export const getNearbyShopsFromLocation = (
    location: ShopLocation,
    shops: Shops,
    threshold: number,
): ShopDetailsWithDistance[] => {
    const shopsClone = _cloneDeep(shops);
    return Object.values(shopsClone)
        .flat()
        .filter((shop) => isNear(location, shop, threshold))
        .map((shop) => ({
            ...shop,
            distance: Math.floor(distance(location, shop)),
        }));
};

export const flattenShopAvailability = (shopAvailability: Shops) => {
    const shopsClone = _cloneDeep(shopAvailability);
    return Object.values(shopsClone).flat();
};
